"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./NavSearch.scss");
var _closeBlue = _interopRequireDefault(require("../../images/close-blue.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const NavSearch = _ref => {
  let {
    deployed,
    searchComponent,
    toggleDesktopSearch,
    mouse,
    isDesktop
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("section", {
    id: "search-modal",
    className: `luna-nav-search__modal ${deployed ? "luna-nav-search__modal--is-deployed" : ""}`
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-nav-search__modal-grid"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-nav-search__modal-box"
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: () => {
      toggleDesktopSearch();
    },
    className: "luna-nav-search__close-button luna-search-close-btn",
    tabIndex: mouse ? "" : "0",
    id: isDesktop ? "desktop-nav-button" : "mobile-nav-button",
    "aria-label": "Close search"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _closeBlue.default,
    className: "luna-nav-search__close-icon",
    alt: "close icon"
  })), deployed && searchComponent)));
};
var _default = NavSearch;
exports.default = _default;